import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ExamCreationModalComponent } from './exam-creation-modal/exam-creation-modal.component';
import { CandidateExamListWidgetComponent } from './candidate-exams-list-widget/candidate-exams-list-widget.component';
import { CandidateDetailsRoutingModule } from './candidate-details-routing.module';
import { CandidateDetailsComponent } from './candidate-details.component';
import { CandidateDescriptionCardComponent } from './candidate-description-card/candidate-description-card.component';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  exports: [ExamCreationModalComponent],
  imports: [
    CommonModule,
    CandidateDetailsRoutingModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    CandidateDetailsComponent,
    CandidateDescriptionCardComponent,
    CandidateExamListWidgetComponent,
    ExamCreationModalComponent,
  ],
})
export class CandidateDetailsModule {}
